import React from "react";

type Props = {
  filterTabs: string[];
  categories: string[];
  selectedFilter: string;
  setSelectedFilter: (value: string) => void;
  selectedCategory: string;
  setSelectedCategory: (value: string) => void;
};

export default function ActivitiesSidebar({
  filterTabs,
  categories,
  selectedFilter,
  setSelectedFilter,
  selectedCategory,
  setSelectedCategory,
}: Props) {
  const handleFilterClick = (tab: string) => {
    setSelectedFilter(tab);
    if (selectedCategory !== 'all') {
      setSelectedCategory('all');
    }
  };

  const handleCategoryClick = (cat: string) => {
    const categoryKey = cat.toLowerCase();
    setSelectedCategory(categoryKey);
    if (selectedFilter !== 'All') {
      setSelectedFilter('All');
    }
  };

  return (
    <aside className="activities-sidebar">
      {filterTabs.map((tab) => (
        <button
          key={tab}
          className={`sidebar-tab ${
            selectedFilter === tab && selectedCategory === 'all' ? "active" : ""
          }`}
          onClick={() => handleFilterClick(tab)}
        >
          {tab}
        </button>
      ))}

      <div className="sidebar-divider" />

      {categories.map((cat) => (
        <button 
          key={cat} 
          className={`sidebar-tab secondary ${
            selectedCategory === cat.toLowerCase() && selectedFilter === 'All' ? "active" : ""
          }`}
          onClick={() => handleCategoryClick(cat)}
        >
          {cat}
        </button>
      ))}
    </aside>
  );
}